import React, { Component } from 'react';
import { Platform, View } from 'react-native';
import config from '../../config';
import I18n from '../../lib/i18n';
import ManageLinesItemsPickerButton from './components/ManageLinesItemsPickerButton';
import type { ContractsActionType } from '../../modules/LegalDocuments/Contracts/actions';
import { openWebLinkInNewTab, openInInternalBrowser } from '../../lib/openURL';
import * as Navigation from '../../lib/navigation.js';

type StateProps = {
  isLoading: boolean,
};

type DispatchProps = {
  fetchContracts: () => ContractsActionType,
};

export type FlaggedProps = {
  canChangePhoneNumber: boolean,
  canCheckContract: boolean,
  canGetRioNumber: boolean,
  canTerminateLine: boolean,
  canWithdrawFromLine: boolean,
};

type Props = FlaggedProps & DispatchProps & StateProps;

export default class ManageLines extends Component<Props> {
  goToLostAndStolen = () => Navigation.navigate('lostAndStolen');
  goToLineTermination = () => Navigation.navigate('lineTermination');
  goToSimReplacement = () => Navigation.navigate('simReplacement');
  goToESimReplacement = () => Navigation.navigate('eSimReplacement');
  goToChangePhoneNumber = () => Navigation.navigate('changePhoneNumber');
  goToPickLineForRioNumber = () => Navigation.navigate('pickLineForRioNumber');

  goToContracts = () => {
    this.props.fetchContracts();
  };

  openWithdrawalFile = () => {
    const url = config.STATIC_FILE_URL.replace('{fileName}', config.STATIC_FILE_NAME.withdrawalAndNotice);

    if (Platform.OS === 'web') {
      openWebLinkInNewTab(url);
    } else {
      openInInternalBrowser(url);
    }
  };

  render() {
    const {
      canChangePhoneNumber,
      canTerminateLine,
      canWithdrawFromLine,
      canGetRioNumber,
      canCheckContract,
      isLoading,
    } = this.props;

    return (
      <View>
        <ManageLinesItemsPickerButton
          label={I18n.t('Dashboard.ManageLines.suspendLostSim')}
          onPress={this.goToLostAndStolen}
        />
        {canTerminateLine && (
          <ManageLinesItemsPickerButton
            label={I18n.t('Dashboard.ManageLines.terminateLine')}
            onPress={this.goToLineTermination}
          />
        )}
        <ManageLinesItemsPickerButton
          label={I18n.t('Dashboard.ManageLines.orderReplacementSim')}
          onPress={this.goToSimReplacement}
        />
        <ManageLinesItemsPickerButton
          label={I18n.t('Dashboard.ManageLines.orderReplacementESim')}
          onPress={this.goToESimReplacement}
        />
        {canWithdrawFromLine && (
          <ManageLinesItemsPickerButton
            label={I18n.t('Dashboard.ManageLines.withdrawFromLine')}
            onPress={this.openWithdrawalFile}
          />
        )}
        {canGetRioNumber && (
          <ManageLinesItemsPickerButton
            label={I18n.t('Dashboard.ManageLines.getRioNumber')}
            onPress={this.goToPickLineForRioNumber}
          />
        )}
        {canChangePhoneNumber && (
          <ManageLinesItemsPickerButton
            label={I18n.t('Dashboard.ManageLines.changePhoneNumber')}
            onPress={this.goToChangePhoneNumber}
          />
        )}
        {canCheckContract && (
          <ManageLinesItemsPickerButton
            label={I18n.t('Dashboard.ManageLines.checkDocuments')}
            onPress={this.goToContracts}
            isLoading={isLoading}
          />
        )}
      </View>
    );
  }
}
